import React, {useEffect, useState} from "react";
import TextField from "@material-ui/core/TextField";
import {Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import {
    parseFloatInputOrEmpty,
    parseIntegerInputOrEmpty,
} from "../../../../utils/forms/parseNumberInput";


const useStyles = makeStyles({
    root: {
        fontSize: 10,
    }
});

export default function CandleBreakTextFields({candleBreak, dispatchCandleBreak}) {
    const classes = useStyles();
    const [candleDurationText, setCandleDurationTxt] = useState(candleBreak.candleDuration);
    const [breakByText, setBreakByTxt] = useState(candleBreak.candleDuration);
    useEffect(() => {
        setCandleDurationTxt(candleBreak.candleDuration);
        setBreakByTxt(candleBreak.breakBy);
    }, [candleBreak])
    return (<Grid item container>
        <Grid item xs={3}>
            <TextField
                className={classes.root}
                value={candleDurationText}
                variant="outlined"
                size="small"
                style={{backgroundColor: "white", width: "100%"}}
                onChange={ev => setCandleDurationTxt(ev.target.value)}
                onBlur={ev => dispatchCandleBreak({candleDuration: parseIntegerInputOrEmpty(ev.target.value)})}
                label={<Typography style={{fontSize: 10}}>candleDuration</Typography>}
            ><Typography style={{fontSize: 1}}>{candleDurationText}</Typography></TextField>
        </Grid>
        <Grid item xs={5}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={candleBreak.waitUntilCurrentCandleCloses}
                        onChange={ev => {
                            dispatchCandleBreak({waitUntilCurrentCandleCloses: ev.target.checked});
                        }}
                        name="waitUntilCurrentCandleCloses"
                    />
                }
                label={<Typography style={{fontSize: 8}}>wait until current candle close</Typography>}
                labelPlacement="top"
            />
        </Grid>
        <Grid item xs={4}>
            <TextField
                className={classes.root}
                value={breakByText}
                variant="outlined"
                size="small"
                style={{backgroundColor: "white", width: "100%"}}
                onChange={ev => setBreakByTxt(ev.target.value)}
                onBlur={ev => dispatchCandleBreak({breakBy: parseFloatInputOrEmpty(ev.target.value)})}
                label={<Typography style={{fontSize: 10}}>break by</Typography>}
            ><Typography style={{fontSize: 1}}>{breakByText}</Typography></TextField>
        </Grid>


    </Grid>);
}
